export const getApiOrigin = async () => {
  const cachedApiOrigin = localStorage.getItem('api_server_url')

  if (cachedApiOrigin !== null) {
    return Promise.resolve(cachedApiOrigin)
  }

  try {
    const apiOriginPromise = fetch('/globalSetting/config')
        .then(res => res.json())
        .then((res) => res.apiServiceUrl)
    const apiOrigin = await apiOriginPromise
    localStorage.setItem('api_server_url', apiOrigin)
    return Promise.resolve(apiOrigin)
  } catch (e) {
    // local dev env
    localStorage.setItem('api_server_url', '')
    return Promise.resolve('')
  }
}